import styled from "styled-components";

import { ConsolePageButtonStyles } from "@Console/components/molecules/ConsolePageForm/atoms/ConsolePageButton/styles";
import { DataTableTemplateContainer } from "@Console/components/molecules/DataTable/templates/DataTableTemplate/styles";

export const ConsoleCommentsTemplateContainer = styled.section`
  max-width: 62.5rem;
  margin: 0 auto;
  padding: 0 1rem;

  margin-bottom: 5rem;

  ${DataTableTemplateContainer} {
    z-index: 1;
  }

  .icon-container {
    display: grid;
    place-items: center;
  }

  #admin-console-pesquisar-por-comentario-e-autor
    > .icon-container
    > ${ConsolePageButtonStyles} {
    padding: 0;
    border: none;
  }

  > .loader {
    margin: 3rem auto;
    width: fit-content;
  }
`;
